import React,{Component} from 'react';
import { browserHistory } from 'react-router';
import WebFooter from './../Common/WebFooter.js';
import { Breadcrumb  } from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import $ from 'jquery';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class Coupon_Details extends Component{
	constructor(props){
		super(props);
		this.state={
			coupon_details: [],
			coupon_status: false,
		}
	}
	componentDidMount(){

		if(screen.width <= 800){
			window.location.href="/coupon/details/"+this.props.params.Cid;
		}

        var data1={from: 'mobile_web', cid:this.props.params.Cid};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getCouponDetails',
            dataType:'json',
            data: {req:data2},
            success: function(data){

               //  var coupon = $.makeArray(data.coupon_details);
                //this.setState({
                //	coupon_details:coupon[0],
                //}); */}
                if(data.status==="success"){
                	var coupon = $.makeArray(data.coupon_details);
                	this.setState({
                		coupon_details:coupon[0],
                	});	
                }
                else if(data.status==="error"){
                	this.setState({
                		coupon_status: true,
                	});
                }
                }.bind(this),
            error: function(err){

            }
        })
	}
  chatnow(){
     if(localStorage.user_id)
     {
       var uid=localStorage.getItem('user_id');
     }
     else
     {
       uid=0;
     }

     if(!localStorage.user_id && !localStorage.token)
     {
       // if(this.props.params.Bname)
       // {
       //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)   
       // }
       // else
       // {
       //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
       // }
       // localStorage.setItem('mob_addtocart','1');
       // localStorage.setItem('mob_addtocart_qty',this.state.min_qty);
       browserHistory.push('/login/'+this.state.wb_url);
     }else{
       location.href=this.state.wb_url;
     }


  }  
render(){
  //document.title ="AquaDeals Customer Care";
  //document.getElementsByTagName("META")[2].content="AquaDeals Customer Care";
      return (
      <div className="lgt_gry web_deals web_coupon_details_page">
          <WebHeaderInner />
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          
          <section className="container">
              <div className="row">
                 <div className="col-md-6 col-md-offset-3">
                 <div className="dels_cntnt web_coupon_details_page">
                        <div className="del_rgt_blk">
                            
                          <div className="clr"></div>
                              <div className="del_dtl">
                                    <div className="">
									{!this.state.coupon_status ? 
									<div>
									<section className="container-fluid coupon_details_main">
										<div className="row coupon_img">
											<img src={baseAssets+"images/"+this.state.coupon_details.img} role="presentation" alt=""/>
										</div>
										<div className="row coupon_details">
											<div className="col-md-12 coupon_specs">
												{this.state.coupon_details.code ? <ul id="coupon_label"><span><li><img src={require('./../../../assets/images/coupon.png')} alt="..."></img></li><li>{this.state.coupon_details.code}</li></span></ul>  : ''}
												{this.state.coupon_details.coupon_title ? <h4>{this.state.coupon_details.coupon_title}{this.state.coupon_details.status ==1 ? <span className="coupon_status_active">ACTIVE</span> : <span className="coupon_status_expired">EXPIRED</span>}</h4> : ''}
												{this.state.coupon_details.date_time_msg ?
												<h3>{this.state.coupon_details.date_time_msg}</h3> 
													: ''} 
												{/*{this.state.coupon_details.applied_on !==0 ? <h5>{this.state.coupon_details.applied_on}</h5> : ''} */}
												
												{/*{this.state.coupon_details.value_msg !==0 ? <h5>{this.state.coupon_details.value_msg}</h5>: ''}*/}
												{/*{this.state.coupon_details.count_msg !==0 ? <h5>{this.state.coupon_details.count_msg}</h5> : ''}*/}						
												{/*{this.state.coupon_details.time_msg !==0 ? <h5>{this.state.coupon_details.time_msg}</h5>: ''}*/}
											</div>												
										</div>		
									</section>
									<div className="coupon_specs_sub_bg">
									<section className="coupon_specs_sub">
										{this.state.coupon_details.applied_on_name!==0 ? <h5>{this.state.coupon_details.applied_on_name}{this.state.coupon_details.value !==0 ? '' : ''}</h5> : ''}					
										{this.state.coupon_details.quantity_msg !==0 ? <h5><Icon
							                    name='circle'
							                    font='MaterialCommunityIcons'
							                    color='#ccc'
							                    size={14}
							                    style={{paddingRight:'3px',top:'1',position:'relative'}}
							                  />{this.state.coupon_details.quantity_msg} </h5> : ''}
										{this.state.coupon_details.applied_on_catname!==0 ? <h5><Icon
							                    name='circle'
							                    font='MaterialCommunityIcons'
							                    color='#ccc'
							                    size={14}
							                    style={{paddingRight:'3px',top:'1',position:'relative'}}
							                  />{this.state.coupon_details.applied_on_catname}</h5>: ''}
									</section>				
									<div className="coupon_dots_blocks"></div>	
									<section className="container-fluid">
										<div className="row coupon_description_blk">
											<div className="col-md-12 col-xs-12 col-sm-12 coupon_description_head">
												{this.state.coupon_details.desc ? <h4>{this.state.coupon_details.desc}</h4> : ''}
											</div>
										</div>
									</section>
									</div>
											<div className="clr">&nbsp;</div>										
											<div className="clr">&nbsp;</div>										
											<div className="clr">&nbsp;</div>
									</div> : <div className="row" style={{textAlign: 'center',color: '#555',margin:'30% auto'}}>No Coupons Available</div> }
                                      </div>
                              </div>
                        </div>
              </div>
          </div>
          </div>

          <div className="clr"></div> 
          </section>

        <div className="cust_car_ftr">
          <WebFooter /> 
        </div>
        
      </div>
  );
    }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Coupons/Web_coupon_details.js
 **/